
import {G2, Line} from '@antv/g2plot';
import {registerShape } from '@antv/g2';
const { registerTheme } = G2;
import store from '../store/index';
import {deepAssign} from "@antv/g2plot/lib/utils";
import {DEFAULT_OPTIONS} from "@antv/g2plot/lib/plots/line/constants";

export class ChartAPI {
    //统计图y轴数据格式, String => Number
    static changeValueFormat = function (data){
        if(!Array.isArray(data)) return;
        data.forEach(elem => {
            if(Array.isArray(elem)){
                //数组--双轴
                elem.forEach(item => {
                    if(item.y){
                        item.y = parseFloat(item.y).toString() === 'NaN' ? '-' : parseFloat(item.y)
                    }
                    if(item.y1){
                        item.y1 = parseFloat(item.y1).toString() === 'NaN' ? '-' : parseFloat(item.y1)
                    }
                })
            }else{
                elem.y = parseFloat(elem.y).toString() === 'NaN' ? '-' : parseFloat(elem.y)
            }
        });
    }


    //屏幕比例变换, 统计图文字, 线宽等改变
    static changeRatio = function(options){
        const keys = ['fontSize', 'lineWidth', 'size', 'r','spacing','itemWidth', 'itemHeight','itemSpacing','maxItemWidth','loopWidth', 'offsetY', 'offsetX'];
        this.changeValueRatio(options, keys, options.ratio || 1);
        options.ratio = store.state.ratio;
    };

    static changeValueRatio = function(options, keys, beforeRatio){
        for(let key in options){
            if(key != 'data'){
                if(key === 'padding' || key === 'appendPadding'){
                    options[key] = options[key].map(elem =>(elem /beforeRatio)* store.state.ratio)
                }
                if(keys.includes(key)){
                    options[key] = (options[key]/beforeRatio) * store.state.ratio;
                }
                if(typeof options[key] === 'object'){
                    this.changeValueRatio(options[key], keys, beforeRatio);
                }
            }
        }
    };

    //注册主题
    static registerChartTheme = function(){
        registerTheme('dark-theme', {
            components :{
                axis:{
                    common:{
                        title: {
                            autoRotate:false,
                            position: 'end',
                            offset: 0,
                            style:{
                                fill:"#0d82ff",
                                fontSize:12*store.state.ratio
                            }
                        },
                        label:{
                            style:{
                                fill:"#0d82ff",
                                fontSize:12*store.state.ratio
                            }
                        },
                        line:{
                            style:{
                                stroke:"#0d82ff",
                                lineWidth: 2*store.state.ratio
                            }
                        },
                        grid: null
                    },
                    left: {
                        position: 'left',
                        title: null,
                        line: {},
                        tickLine: null,
                        verticalLimitLength: 1 / 3,
                    },
                    right: {
                        position: 'right',
                        title: null,
                        line: {},
                        tickLine: null,
                        verticalLimitLength: 1 / 3,
                    },
                    bottom:{
                        tickLine: null,
                        title:{
                            offset: 14
                        }
                    }
                },
                annotation:{
                    text:{
                        style:{
                            fill:"#0d82ff",
                            fontSize: 12*store.state.ratio
                        }
                    },
                    line:{
                        style:{
                            stroke:"#0d82ff",
                        }
                    }
                },
                legend:{
                    common:{
                        maxItemWidth: 500*store.state.ratio,
                        itemSpacing: 10*store.state.ratio
                    }
                }


            }
        });

        registerTheme('light-theme', {
            components :{
                axis:{
                    common:{
                        title: {
                            autoRotate:false,
                            position: 'end',
                            offset: 14,
                            style:{
                                fill:"#A6B6C6",
                                fontSize:12
                            }
                        },
                        label:{
                            style:{
                                fill:"#A6B6C6",
                                fontSize:12
                            }
                        },
                        line:{
                            style:{
                                stroke:"#A6B6C6"
                            }
                        },
                        grid: null
                    },
                    left: {
                        position: 'left',
                        title: null,
                        line: {},
                        tickLine: null,
                        verticalLimitLength: 1 / 3,
                    },
                    right: {
                        position: 'right',
                        title: null,
                        line: {},
                        tickLine: null,
                        verticalLimitLength: 1 / 3,
                    },
                    bottom:{
                        tickLine: null,
                    }
                },
                annotation:{
                    text:{
                        style:{
                            fill:"#A6B6C6",
                            fontSize:12
                        }
                    }
                }


            }
        });
    }

    //注册形状
    static registerChartShape = function(){
        registerShape('interval', 'custom-rose', {
            draw(cfg, container) {
                const points = cfg.points;
                const origin = cfg.data;
                const percent = origin.y / cfg.customInfo.max;
                const xWidth = points[2].x - points[1].x;
                const width = xWidth * percent;
                let path = [];
                path.push(['M', points[0].x, points[0].y]);
                path.push(['L', points[1].x, points[1].y]);
                path.push(['L', points[0].x + width, points[2].y]);
                path.push(['L', points[0].x + width, points[3].y]);
                path.push('Z');
                path = this.parsePath(path);
                return container.addShape('path', {
                    attrs: {
                        fill: cfg.color,
                        path,
                    },
                });
            },
        });

        registerShape('point', 'pointer', {
            draw(cfg, container) {
                const group = container.addGroup();
                const center = this.parsePoint({ x: 0, y: 0 }); // 获取极坐标系下画布中心点
                const point = cfg.points[0];
                const target = this.parsePoint({ x: point.x, y: 1 });
                const dir_vec = { x: center.x - target.x, y: center.y - target.y };
                const length = Math.sqrt(dir_vec.x * dir_vec.x + dir_vec.y * dir_vec.y);
                //在value处绘制一个圆
                group.addShape('circle', {
                    attrs: {
                        x: target.x,
                        y: target.y,
                        r: cfg.customInfo.circle.radius,
                        fill: cfg.color,
                        shadowColor: cfg.color,
                        shadowBlur: 10
                    },
                });
                //绘制一个环
                group.addShape('circle', {
                    attrs: {
                        x: center.x,
                        y: center.y,
                        r: length - cfg.customInfo.loop.offset,
                        stroke: cfg.customInfo.loop.color,
                        lineWidth: 2,
                    },
                });

                return group;
            },
        });
    }

    //默认配置统计图的配置属性
    static setDefaultOptions = function (){
        Line.getDefaultOptions = function(){
            return deepAssign({}, DEFAULT_OPTIONS, {
                yAxis: {
                    tickMethod: 'd3-linear'
                }
            });
        }
    }
}
